import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  avatars: {
    cursor: "pointer",
  },
}))

export default styles
